import React, { useState } from 'react';
import { ListMusic, Lock, Plus, X } from 'lucide-react';
import { Panel, AddButton, RowButton, StatusToggle, PageHeading } from '../ui';
import { ACTIVITIES, PLAYLISTS } from '../../../lib/familyData';
export function PlaylistBuilder() {
  const [status, setStatus] = useState<Record<string, boolean>>(() => Object.fromEntries(PLAYLISTS.map(p => [p.id, true])));
  const [building, setBuilding] = useState<string[]>(['a1', 'a2']);
  const toggleActivity = (id: string) => setBuilding(b => b.includes(id) ? b.filter(x => x !== id) : [...b, id]);
  return <div data-id="element-515" data-mp="3vsmuz9p3il9a">
      <PageHeading title="Playlist Builder" subtitle="Curate parent playlists from published curriculum activities. Content is pulled per lang (en / hi / mr)." data-id="element-516" data-mp="3vr1wxa3kok6o" />

      <div className="grid gap-5 xl:grid-cols-3" data-id="element-517" data-mp="2kcex3lklzy3y">
        <div className="xl:col-span-2" data-id="element-518" data-mp="2kbn48iiecehd">
          <Panel title="Playlists" icon={<ListMusic className="h-4 w-4 text-[#1e2a5a]" data-id="element-520" data-mp="2pdcgg1hcuy71" />} action={<AddButton label="New playlist" data-id="element-521" data-mp="3gswkhuvls2ow" />} data-id="element-519" data-mp="2pckhqhsgokcj">
            <table className="w-full text-sm" data-id="element-522" data-mp="3bss5yae99i1b">
              <thead data-id="element-523" data-mp="3bu24f0p0ss8h">
                <tr className="border-b border-slate-200 text-left text-slate-600" data-id="element-524" data-mp="3bulfpyk60idj">
                  <th className="px-5 py-3 font-semibold" data-id="element-525" data-mp="3qrm4puaz1z8b">Name</th>
                  <th className="px-5 py-3 font-semibold" data-id="element-526" data-mp="3lqoovodfph9z">Category</th>
                  <th className="px-5 py-3 font-semibold" data-id="element-527" data-mp="3lbnjybty1vf">Activities</th>
                  <th className="px-5 py-3 font-semibold" data-id="element-528" data-mp="3jide920czio">Status</th>
                  <th className="px-5 py-3 text-right font-semibold" data-id="element-529" data-mp="3uql4l0huj5sw">Actions</th>
                </tr>
              </thead>
              <tbody data-id="element-530" data-mp="dad3xpmael9x">
                {PLAYLISTS.map(p => <tr key={p.id} className="border-b border-slate-100 last:border-0" data-id="element-531" data-mp="8bs2jmvatvjw">
                    <td className="px-5 py-3.5 font-medium text-slate-800" data-id="element-532" data-mp="m9qgir5pjpyv">
                      {p.name}
                    </td>
                    <td className="px-5 py-3.5" data-id="element-533" data-mp="pdo56b1tu8bo">
                      <span className="rounded-full px-2.5 py-0.5 text-xs font-semibold text-white" style={{
                    backgroundColor: p.color
                  }} data-id="element-534" data-mp="pez51zs5ivxi">
                        {p.category}
                      </span>
                    </td>
                    <td className="px-5 py-3.5 text-slate-600" data-id="element-535" data-mp="143vgm6tf2r2v">
                      {p.activityIds.length}
                    </td>
                    <td className="px-5 py-3.5" data-id="element-536" data-mp="1d30bn35rs2aa">
                      <StatusToggle on={status[p.id]} onToggle={() => setStatus(s => ({
                    ...s,
                    [p.id]: !s[p.id]
                  }))} data-id="element-537" data-mp="1d1p6aywoemh2" />
                    </td>
                    <td className="px-5 py-3.5" data-id="element-538" data-mp="3jtzrtw409gci">
                      <div className="flex justify-end gap-2" data-id="element-539" data-mp="3jvauttpmmk2k">
                        <RowButton variant="read" data-id="element-540" data-mp="3orrkwtgdz8ia">Read</RowButton>
                        <RowButton variant="edit" data-id="element-541" data-mp="25xevo1jxescg">Edit</RowButton>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </Panel>
        </div>

        {/* Builder canvas */}
        <Panel title="New Playlist" icon={<Plus className="h-4 w-4 text-[#1e2a5a]" data-id="element-543" data-mp="1x2qqebecpann" />} data-id="element-542" data-mp="1x5mpi31xq5do">
          <div className="p-5" data-id="element-544" data-mp="1s7bfnsbn3uvg">
            <label className="mb-1 block text-xs font-semibold text-slate-600" data-id="element-545" data-mp="1s3xg0rud1zrp">
              Playlist name
            </label>
            <input placeholder="e.g. Calm Bedtime Rituals" className="mb-4 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-[#1e2a5a] focus:outline-none" data-id="element-546" data-mp="2kuyzh5536hh1" />
            <p className="mb-2 text-xs font-semibold text-slate-600" data-id="element-547" data-mp="2axb0g30g6nt2">
              Selected ({building.length})
            </p>
            <div className="mb-4 flex flex-wrap gap-1.5" data-id="element-548" data-mp="14i0n2y4g16se">
              {building.length === 0 && <span className="text-xs text-slate-400" data-id="element-549" data-mp="zg1ixm0vq5ue">
                  Pick activities below.
                </span>}
              {building.map(id => {
              const a = ACTIVITIES.find(x => x.id === id)!;
              return <span key={id} className="flex items-center gap-1 rounded-full bg-[#1e2a5a] px-2.5 py-1 text-xs text-white" data-id="element-550" data-mp="2ee5llopsxed4">
                    {a.title}
                    <button onClick={() => toggleActivity(id)} aria-label="Remove" data-id="element-551" data-mp="373crj8rl568e">
                      <X className="h-3 w-3" data-id="element-552" data-mp="3b2lkibesx02w" />
                    </button>
                  </span>;
            })}
            </div>
            <div className="max-h-72 space-y-1.5 overflow-y-auto pr-1" data-id="element-553" data-mp="2x68312a9oyof">
              {ACTIVITIES.map(a => {
              const added = building.includes(a.id);
              return <button key={a.id} onClick={() => toggleActivity(a.id)} className={`flex w-full items-center justify-between rounded-md border px-3 py-2 text-left text-sm transition ${added ? 'border-[#1e2a5a] bg-[#1e2a5a]/5' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-554" data-mp="1lqrqzx9ksuw6">
                    <span className="min-w-0" data-id="element-555" data-mp="1n5m6nab9kb3o">
                      <span className="block truncate font-medium text-slate-800" data-id="element-556" data-mp="1n3rhfjsylwts">
                        {a.title}
                      </span>
                      <span className="text-xs text-slate-500" data-id="element-557" data-mp="vfhdon9fufqu">
                        {a.umbrella} · {a.duration}m · Age {a.ageGroup}
                      </span>
                    </span>
                    {a.locked && <Lock className="h-3.5 w-3.5 shrink-0 text-amber-500" data-id="element-558" data-mp="14dtdnfw72pvy" />}
                  </button>;
            })}
            </div>
            <button className="mt-4 w-full rounded-md bg-[#1e2a5a] py-2.5 text-sm font-semibold text-white hover:bg-[#2a3a70]" data-id="element-559" data-mp="brgys67xjh32">
              Save playlist
            </button>
          </div>
        </Panel>
      </div>
    </div>;
}